import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { privateRoutes, publicRoutes } from 'router/routes';
import PrivateRoute from 'router/PrivateRoute';
import { getUniqueKey } from 'utils';
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs';

const Router = () => (
  <Routes>
    {/* authenticated routes (standard routes) */}
    {privateRoutes.map((route) => (
      <Route
        path={route.path}
        key={getUniqueKey(route)}
        element={
          <PrivateRoute permission={route?.permission}>
            {/*{route.showBreadcrumbs && <Breadcrumbs />}*/}
            {route.element}
          </PrivateRoute>
        }
      />
    ))}
    {/* public routes */}
    {publicRoutes.map((route) => (
      <Route path={route.path} key={route.path} element={route.element} />
    ))}
  </Routes>
);

export default Router;
